import { KeyboardEvent } from 'react';

type Props = {
    componentId: string;
    dir: string;
}

const useTabsA11y = ({ componentId, dir }: Props) => {

    const getActiveTabs = () => {
        const carouselActiveTabsSelector = `.swiper-slide.swiper-slide-active #carousel-tabs-${componentId} .react-tabs__tab`;
        const nonCarouselTabsSelector = `#carousel-tabs-${componentId} .react-tabs__tab`;
        const swiperSlideSelector = `#Carousel-${componentId} .swiper-slide`;
        const hasCarouselSlides = !!document.querySelector(swiperSlideSelector);

        const tabsSelector = hasCarouselSlides ? carouselActiveTabsSelector : nonCarouselTabsSelector;
        return document.querySelectorAll(tabsSelector);
    };

    const onKeydown_tab = (event: KeyboardEvent<HTMLElement>) => { onKeydown(event); };

    const onKeydown = (event: KeyboardEvent<HTMLElement>) => {
        const tgt = event.currentTarget;
        let flag = false;
        const tabs = getActiveTabs();

        switch (event.key) {
            case 'ArrowLeft':
                dir === "rtl" ? moveFocusToNextTab(tgt) : moveFocusToPreviousTab(tgt);
                flag = true;
                break;
            case 'ArrowRight':
                dir === "rtl" ? moveFocusToPreviousTab(tgt) : moveFocusToNextTab(tgt);
                flag = true;
                break;
            case 'Home':
                moveFocusToTab(tabs[0].id);
                flag = true;
                break;
            case 'End':
                moveFocusToTab(tabs[tabs.length - 1].id);
                flag = true;
                break;
            default:
                break;
        }
        if (flag) {
            event.stopPropagation();
            event.preventDefault();
        }
    }

    const moveFocusToTab = (currentTabID: string) => {
        const tab = document.getElementById(currentTabID);
        if (tab) {
            return (tab as HTMLElement).focus();
        }
    }

    const moveFocusToPreviousTab = (currentTab: EventTarget & HTMLElement) => {
        let index;
        const tabs = getActiveTabs();
        let tabs_arr = Array.from(tabs);
        if (currentTab === tabs[0]) {
            moveFocusToTab(tabs[tabs.length - 1].id);
        } else {
            index = tabs_arr.indexOf(currentTab);
            moveFocusToTab(tabs_arr[index - 1].id);
        }
    }

    const moveFocusToNextTab = (currentTab: EventTarget & HTMLElement) => {
        let index;
        const tabs = getActiveTabs();
        let tabs_arr = Array.from(tabs);

        if (currentTab === tabs[tabs.length - 1]) {
            moveFocusToTab(tabs[0].id);
        } else {
            index = tabs_arr.indexOf(currentTab);
            moveFocusToTab(tabs_arr[index + 1].id);
        }
    }

    return {
        onKeydown_tab
    }
}

export default useTabsA11y;